<!-- ----------------------------------------------- -->
<template>
  <transition name="modal" appear>
    <div class="com-modal com-modal-overlay" @click.self="$emit('close')">
      <v-col class="com-pc-graph pa-0" ref="diagBox">
        <v-row class="com-pc-card-header">
          <span class="com-pc-card-title">{{ text.title }}</span>
          <v-spacer></v-spacer>
          <v-btn small text icon color="white" @click="$emit('close')">
            <v-icon>highlight_off</v-icon>
          </v-btn>
        </v-row>
        <v-col class="com-pc-card-contents">
          <tm-dam-diag
            :width="width"
            :height="height"
            :isHour="diagSwitch.selectTime"
          ></tm-dam-diag>
          <v-col class="pa-0">
            <v-row class="tm-pc-graph-select-box pa-1">
              <v-spacer></v-spacer>
              <v-btn
                tile
                depressed
                small
                color="success"
                width="60px"
                :outlined="diagSwitch.selectTime === false"
                @click="diagSwitch.selectTime = true"
                >{{ btn.timehour }}</v-btn
              >
              <v-btn
                tile
                depressed
                small
                color="success"
                width="60px"
                :outlined="diagSwitch.selectTime === true"
                @click="diagSwitch.selectTime = false"
                class="mr-1"
                >{{ btn.time10 }}</v-btn
              >
            </v-row>
          </v-col>
        </v-col>
      </v-col>
    </div>
  </transition>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 [PC]ダム模式図ダイアログ
 * TmDamDiagDlg.vue
 * @author ILUKE
 */

import TmDamDiag from "./TmDamDiag.vue";

export default {
  name: "tm-dam-diag-dlg",
  components: {
    TmDamDiag,
  },
  props: {
    /** 時間/10分指定 */
    isHour: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      /** 文字列リソース */
      text: {
        title: "ダム模式図",
      },
      btn: {
        timehour: "時間毎",
        time10: "10分毎",
      },
      width: 10,
      height: 10,
      diagSwitch: {
        selectTime: true,
      },
    };
  },
  created() {
    window.addEventListener("resize", this.handleResize);
  },
  mounted() {
    this.diagSwitch.selectTime = this.isHour;
    this.handleResize();
  },
  updated() {
    this.handleResize();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.$nextTick(() => {
        if (this.$refs.diagBox !== undefined) {
          const offsetWidth = this.$refs.diagBox.offsetWidth;
          const offsetHeight = this.$refs.diagBox.offsetHeight;
          if (offsetWidth > 0 && offsetHeight > 0) {
            this.width = offsetWidth - 500;
            this.height = offsetHeight - 140;
          }
        }
      });
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped></style>
